/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ max: NonNullable<unknown> }} Position_Modal_Character_Position_LabelInputs */



/**
* | output |
* | --- |
* | "Character Position (1-{max})" |
*
* @param {Position_Modal_Character_Position_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const position_modal_character_position_label = /** @type {((inputs: Position_Modal_Character_Position_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Position_Modal_Character_Position_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Position des caracteres (1-${i?.max})`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Zeichenposition (1-${i?.max})`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Posizione del personaggio (1-${i?.max})`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Позиция символа (1-${i?.max})`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Posición del personaje (1-${i?.max})`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`字符位置（1-${i?.max}）`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`文字位置 (1-${i?.max})`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`चरित्र स्थिति (1-${i?.max})`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Posição do caractere (1-${i?.max})`)
	return /** @type {LocalizedString} */ (`Character Position (1-${i?.max})`)
});